function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { join, split } from 'lodash';
export var PreguntaForm = /*#__PURE__*/function () {
  function PreguntaForm(data) {
    _classCallCheck(this, PreguntaForm);
    _defineProperty(this, "options", []);
    this.data = data;
    this.eliminar = false;
  }
  return _createClass(PreguntaForm, [{
    key: "permiteEditar",
    get: function get() {
      return this.q && this.q.tipoq === 'MULTIPLE';
    }
  }, {
    key: "pregEnlazada",
    get: function get() {
      return !!this.q;
    }
  }, {
    key: "update",
    value: function update(response) {
      if (response.q) {
        this.q = response.q;
        this.title = response.q && response.q.texto_en;
        this.tipoq = response.q && response.q.tipoq;

        // generar las opciones del select, están en la pregunta del bloque
        if (response.q.tipoq == 'MULTIPLE') {
          this.options = split(this.data.options, '|');
        }
      }
      this.eliminar = false;
      return this;
    }
  }, {
    key: "toggleVisible",
    value: function toggleVisible() {
      this.data.visibleEnForm = !this.data.visibleEnForm;
    }
  }, {
    key: "toggleEliminar",
    value: function toggleEliminar() {
      this.eliminar = !this.eliminar;
    }
  }, {
    key: "desdePregunta",
    value: function desdePregunta(p) {
      this.q = p;
      this.data.quest_id = p.idquest;
      this.title = p.texto_en;
      this.tipoq = p.tipoq;
    }
  }, {
    key: "beforeSave",
    value: function beforeSave() {
      // generar las opciones del select
      if (this.q && this.q.tipoq == 'MULTIPLE') {
        this.data.options = join(this.options, '|');
      }
    }
  }]);
}();